import getSelectedTableView from '../../utils/getSelectedTableView';
import setMultiSelectPerfDatapoint from './setMultiSelectPerfDatapoint';
import { action } from 'satcheljs/lib/legacy';
import { PerformanceDatapoint } from 'owa-analytics';

type MultiSelectSource = 'Persona' | 'MailListItem';

export default action('multiSelectItems')(function multiSelectItems(
    itemId: string,
    source: MultiSelectSource
) {
    const tableView = getSelectedTableView();

    if (!tableView.isInCheckedMode) {
        tableView.isInCheckedMode = true;
        const datapoint = new PerformanceDatapoint('EnableMultiSelect');
        datapoint.addCustomData({
            source,
        });
        setMultiSelectPerfDatapoint(datapoint);
    }

    if (tableView.isInVirtualSelectAllMode) {
        // If in virtual select all mode
        const itemIndex = tableView.virutalSelectAllExclusionList.indexOf(itemId);
        if (itemIndex < 0) {
            // if item doesn't exist in virutalSelectAllExclusionList, add it
            // i.e. user unchecks this item after select all
            tableView.virutalSelectAllExclusionList.push(itemId);
        } else {
            // otherwise, remove it
            // i.e. user unchecked this item before and now checks it again
            tableView.virutalSelectAllExclusionList.splice(itemIndex, 1);
        }
    } else {
        // If in non-virtual multi select state
        if (tableView.selectedItemsIds.has(itemId)) {
            // if item already exists, remove it
            tableView.selectedItemsIds.delete(itemId);
        } else {
            // otherwise, add it.
            tableView.selectedItemsIds.set(itemId, true);
        }
    }
});
